import * as React from "react";
import { getIcon } from "material-file-icons";
import { Box } from "@mui/material";

interface FileIconProps {
  filename?: string;
  mimetype?: string;
  size?: number;
}

export const FileIcon: React.FC<FileIconProps> = ({
  filename,
  mimetype,
  size = 24,
}) => {
  const icon = React.useMemo(() => {
    if (filename) {
      return getIcon(filename);
    }
    if (mimetype) {
      const ext = mimetype.split("/")[1] || "file";
      return getIcon(`file.${ext}`);
    }
    return getIcon("file");
  }, [filename, mimetype]);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        "& svg": {
          width: "100%",
          height: "100%",
        },
      }}
      dangerouslySetInnerHTML={{ __html: icon.svg }}
    />
  );
};
